var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{attrs:{"label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"validate-status":_vm.finalStatus,"help":_vm.finalHelp,"hasFeedback":_vm.hasFeedback}},[_c('template',{slot:"label"},[(_vm.required)?_c('span',{staticClass:"dol-form-item__required"},[_vm._v("*")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }